import { Injectable } from '@angular/core';
import { ProductGroup } from '../models/products-group';
import { Observable, of } from 'rxjs';
import { ProductsService } from './products.service';
import { Product } from '../models/product';
import { OrderLineType } from '../models/order-line-type';
import { ProductStockInformation } from '../models/product-stock-information';
import { Category } from '../models/category';


@Injectable()
export class ProductsInMemoryService implements ProductsService {

  private allProductsGroup: ProductGroup[] = [
    new ProductGroup(
      OrderLineType.Fee,
      [
        new Product(100, 'Service Fee', 0.5, 0.19)
      ]),
    new ProductGroup(
      OrderLineType.GiftCard,
      [
        new Product(200, 'GiftCard', 1, null),
        new Product(201, 'GiftCard 25', 25, null),
        new Product(202, 'GiftCard 50', 50, null),
        new Product(203, 'GiftCard 75', 75, null),
        new Product(204, 'GiftCard 100', 100, null),
      ]),
    new ProductGroup(
      OrderLineType.AdditionalProduct,
      [
        new Product(300, 'Socken', 2.50, 0.19, '', 'Das Socken ist ein Arm-Bändchen, das mit einem ID-Chip versehen ist. Es dient zur Nutzung des Wertschließfaches und erleichtert den Check-In auf die Trampolin-Fläche. Es kann ohne Probleme während des Trampolinspringens getragen werden.'),
        new Product(301, 'Flight Ribbon', 2.50, 0.19, '', 'Das Flight-Ribbon ist ein Arm-Bändchen, das mit einem ID-Chip versehen ist. Es dient zur Nutzung des Wertschließfaches und erleichtert den Check-In auf die Trampolin-Fläche. Es kann ohne Probleme während des Trampolinspringens getragen werden.'),
      ]),
    new ProductGroup(
      OrderLineType.Product,
      [
        new Product(1, 'Product 1', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 1),
        new Product(2, 'Product 2', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 1),
        new Product(3, 'Product 3', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 1),
        new Product(4, 'Product 4', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 1),
        new Product(5, 'Product 5', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 1),

        new Product(6, 'Product 1.1', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 2),
        new Product(7, 'Product 1.2', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 2),

        new Product(8, 'Product 1.1.1', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 4),
        new Product(9, 'Product 1.1.2', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 4),

        new Product(10, 'Product 1.3.1', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 6),

        new Product(11, 'Product 1.3.1.1', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 7),

        new Product(12, 'Product 3.1', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 8),
        new Product(13, 'Product 3.2', 1, 0, null, 'Description', null, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 8),
      ]),
  ];

  get allProducts(): Observable<ProductGroup[]> {
    return of(this.allProductsGroup);
  }

  checkIsAvailableProductOnStock(stockProductRequestQuantity: ProductStockInformation[]): Observable<ProductStockInformation[]> {
    return of(stockProductRequestQuantity);
  }


  checkProductPin(productId: number, pin: string): Observable<boolean> {
    return of(false);
  }

  findVariantProductByPin(pin: string, productTemplateId: number): Observable<number> {
    return of(0);
  }

  get categories(): Observable<Category[]> {
    return of([
      new Category(1, 'Category All', null, 0, true),
      new Category(2, 'Sub Category 1', null, 1),
      new Category(3, 'Sub Category 2', null, 1),
      new Category(4, 'Sub Category 1.1', null, 2),
      new Category(5, 'Sub Category 1.2', null, 2),
      new Category(6, 'Sub Category 1.3', null, 2),
      new Category(7, 'Sub Category 1.3.1', null, 6),
      new Category(8, 'Sub Category 3', null, 1),
    ]);
  }
}
